<template>
  <div class="theme">
    <myMenu :type="2" @zoomChange="initWow"></myMenu>
    <div class="pao pao2 wow slideInLeftSelf"></div>
    <div class="theme_content">
      <div class="linear_word">ANNOUNCEMENT</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">动态公告</div>
      </div>
      <div class="theme_list wow slideInUp" data-wow-delay="0.6s">
        <div class="no_list" v-if="dataList.length==0">
          <img src="@/assets/no-data.png" alt="" srcset="">
          <span>暂无数据</span>
        </div>
        <div @click="newsDec(item)" class="theme_item " v-for="(item,index) in dataList" :key="index">
          <div class="theme_item_img">
            <p class="item_mouth">{{item.mouth}}/{{item.day}}</p>
            <p class="item_year">{{item.year}}</p>
          </div>
          <div class="theme_item_left">
            <p class="item_name">{{item.news_title}}</p>
            <p class="item_dec">{{item.news_demo}}</p>
          </div>
        </div>
      </div>
    </div>
    <myBottom></myBottom>
  </div>
</template>

<script>
import myMenu from '@/components/myMenu.vue'
import myBottom from '@/components/myBottom.vue'

import "wowjs/css/libs/animate.css";
import "@/assets/css/wowExtra.css";
import { WOW } from 'wowjs'
export default {
  components: { myMenu, myBottom, },
  data() {
    return {
      dataList: [],
    }
  },
  created() {

  },
  mounted() {
    P_getNewsList({
      park_id: this.$ParkId,
      news_type: 5,
      pageIndex: 1,
      pageSize: 10
    }).then((res) => {
      if (res.success) {
        if (res.success) {
          res.data.map(item => {
            item.year = this.$time(item.news_time, 'YYYY')
            item.mouth = this.$time(item.news_time, 'MM')
            item.day = this.$time(item.news_time, 'DD')
          })
          this.dataList = res.data;
        }
      }
    })
  },
  methods: {
    initWow(zoom) {
      var top = $('.theme_list').offset().top;
      var offset = zoom >= 1 ? 200 * zoom : (200 * zoom - (top - top * zoom));
      var wow = new WOW(
        {
          animateClass: 'animated',
          offset,
          callback: box => {
            $(box).removeClass('wow');
          }
        }
      );
      wow.init();
    },
    newsDec(item) {
      this.$toPage(item.news_redirect || '/newsdetail', { id: item.news_id });
    },
  },
}
</script>

<style lang="scss" scoped>
.theme {
  .pao1 {
    left: 620px;
    top: 700px;
  }
  .theme_content {
    width: 1320px;
    margin: 150px auto 180px;
    position: relative;
    z-index: 1;
    .theme_list {
      margin-top: 74px;
      padding: 47px 37px;
      box-shadow: 0px 8px 54px 0px rgba(111, 159, 227, 0.3);
      border-radius: 20px;
      background: rgba(255, 255, 255, 0.8);
    }
    .no_list {
      height: 600px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      span {
        color: #999;
        margin-top: -162px;
        font-size: 20px;
      }
    }
    .theme_item {
      height: 153px;
      background: linear-gradient(90deg, #ee62431c 40%, #fda96500);
      border-radius: 26px;
      margin-bottom: 43px;
      cursor: pointer;
      display: flex;
      margin-right: 50px;
      &:nth-child(3n + 2) {
        background: linear-gradient(90deg, #67efea1c 40%, #fda96500);
      }
      &:nth-child(3n + 1) {
        background: linear-gradient(90deg, #ee62431c 40%, #fda96500);
      }
      &:nth-child(3n + 3) {
        background: linear-gradient(90deg, #725eda1c 40%, #fda96500);
      }
      &:last-child {
        margin-bottom: 0;
      }
      .theme_item_img {
        width: 111px;
        border-radius: 26px;
        position: relative;
        flex-shrink: 0;
        margin-left: 34px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .item_mouth {
          font-size: 38px;
          font-family: SourceHanSansCN;
          font-weight: 800;
          color: #000000;
          border-bottom: 1px solid #000;
        }
        .item_year {
          font-size: 26px;
          font-family: SourceHanSansCN;
          font-weight: 400;
          color: #000000;
        }
      }
      .theme_item_left {
        margin-left: 128px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .item_name {
          font-size: 27px;
          font-weight: bold;
          color: #1f1f1f;
          transition: all 0.3s;
        }

        .item_dec {
          font-size: 26px;
          font-family: SourceHanSansCN;
          font-weight: 400;
          color: #1f1f1f;
          line-height: 48px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        &:hover {
          .item_name {
            color: #274455;
            text-decoration: underline;
          }
        }
      }
    }
  }
}

.page_ctrl {
  text-align: center;
  margin: 0 auto;
  box-sizing: border-box;
}

.page_ctrl * {
  line-height: 27px;
}

.page_ctrl button {
  margin: 0 3px;
  padding: 0 4px;
  min-width: 27px;
  background: none;
  border: 1px solid #47a2f4;
  color: #47a2f4;
  cursor: pointer;
  outline: none;
  border-radius: 4px;
  text-align: center;
}

.page_ctrl button:hover {
  background: #47a2f4;
  color: #ffffff;
}

.page_ctrl .btn_dis {
  cursor: default;
  opacity: 0.7;
  background: #ddd;
  color: #5e5e5e;
  cursor: pointer;
}

.page_ctrl .btn_dis:hover {
  background: #eeeeee;
  color: #5e5e5e;
}

.page_ctrl .current_page {
  background: #47a2f4;
  color: #ffffff;
}

.page_ctrl .input_page_num {
  width: 30px;
  height: 26px;
  margin: 0 3px;
  padding: 0;
  text-align: center;
  background: transparent;
  border: 1px solid #47a2f4;
  color: #47a2f4;
  border-radius: 4px;
  outline: none;
}

.page_ctrl .page_total,
.page_ctrl .page_text {
  color: #2b2b2b;
  font-size: 13px;
}

.page_ctrl .page_dot {
  vertical-align: bottom;
  color: #5e5e5e;
}
.pao2 {
  border-radius: 50%;
  background-image: -moz-linear-gradient(
    120deg,
    rgb(149, 219, 255) 0%,
    rgb(34, 107, 255) 81%
  );
  background-image: -webkit-linear-gradient(
    120deg,
    rgb(149, 219, 255) 0%,
    rgb(34, 107, 255) 81%
  );
  background-image: -ms-linear-gradient(
    120deg,
    rgb(149, 219, 255) 0%,
    rgb(34, 107, 255) 81%
  );
  background-image: linear-gradient(
    120deg,
    rgb(149, 219, 255) 0%,
    rgb(34, 107, 255) 81%
  );
  opacity: 0.7;
  left: -200px;
  top: 1003px;
  width: 303px;
  height: 303px;
}
.more_btn {
  width: 52px;
  height: 163px;
  border: 2px solid #7d7d7d;
  border-radius: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;
  position: absolute;
  right: 20px;
  bottom: 20px;
  cursor: pointer;
  transition: all 0.3s;

  span {
    font-size: 25px;
    color: rgb(125, 125, 125);
    word-wrap: break-word;
    display: inline-block;
    line-height: 22px;
    width: 82px;
    transform: rotate(90deg);
    margin-top: 35px;
    transition: all 0.3s;
  }
  i {
    width: 20px;
    height: 20px;
    background-color: #7d7d7dff;
    border-radius: 50%;
    margin-top: 30px;
    background-image: url('../assets/arrow5.png');
    background-size: 12px 12px;
    background-repeat: no-repeat;
    background-position: 1px center;
    transform: rotate(90deg);
    transition: all 0.3s;
  }
  &:hover {
    span {
      color: #48b8fb;
    }
    i {
      background-color: #48b8fb;
    }
    border: 1px solid #48b8fb;
  }
}
</style>